var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "params-form" },
        [
          _c(
            "a-form-model",
            {
              ref: "searchForm",
              attrs: { layout: "inline", model: _vm.formState },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "任务编号", prop: "taskCode" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入任务编号" },
                    model: {
                      value: _vm.formState.taskCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "taskCode", $$v)
                      },
                      expression: "formState.taskCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "检查时间", prop: "checkDate" } },
                [
                  _c("a-ext-data-picker", {
                    model: {
                      value: _vm.formState.checkDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "checkDate", $$v)
                      },
                      expression: "formState.checkDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "被检机构名称", prop: "name" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入被检机构名称" },
                    model: {
                      value: _vm.formState.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "name", $$v)
                      },
                      expression: "formState.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "任务状态", prop: "taskStatus" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "100px" },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "DoubleCheckStatus" },
                        model: {
                          value: _vm.formState.taskStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "taskStatus", $$v)
                          },
                          expression: "formState.taskStatus",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "专家姓名", prop: "zhuanjiaName" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入专家姓名" },
                    model: {
                      value: _vm.formState.zhuanjiaName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formState, "zhuanjiaName", $$v)
                      },
                      expression: "formState.zhuanjiaName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "检查结果", prop: "taskPass" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", width: "100px" },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "DoubleCheckResult" },
                        model: {
                          value: _vm.formState.taskPass,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "taskPass", $$v)
                          },
                          expression: "formState.taskPass",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                [
                  _c(
                    "a-space",
                    [
                      _c("a-button", { on: { click: _vm.onResetSearch } }, [
                        _vm._v("重置"),
                      ]),
                      _c("a-divider", {
                        attrs: { dashed: "true", type: "vertical" },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSearchPage },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-content" },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { width: "350px", display: "inline-block" },
              },
              [
                _vm._v(" 检测机构双随机检查 "),
                _vm.selectedRowCount
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "150px",
                          display: "inline-block",
                          "line-height": "20px",
                          color: "darkorange",
                        },
                      },
                      [_vm._v(" 共选择" + _vm._s(_vm.selectedRowCount) + "条 ")]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                staticStyle: {
                  width: "calc(100% - 350px)",
                  display: "inline-block",
                  "text-align": "right",
                },
              },
              [
                _c(
                  "a-space",
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAddDbRandomModalOpen },
                      },
                      [_vm._v("生成任务")]
                    ),
                    _c("a-divider", {
                      attrs: { dashed: "true", type: "vertical" },
                    }),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExportExcel },
                      },
                      [_vm._v("导出excel")]
                    ),
                    _c("a-divider", {
                      attrs: { dashed: "true", type: "vertical" },
                    }),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.onBatchDelete },
                      },
                      [_vm._v("批量删除")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "a-config-provider",
            { attrs: { locale: _vm.locale } },
            [
              _c("a-table", {
                attrs: {
                  "data-source": _vm.dataSource,
                  columns: _vm.columns,
                  pagination: _vm.pagination,
                  loading: _vm.loading,
                  "row-key": "id",
                  "row-selection": {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                  },
                  scroll: { y: 500 },
                },
                on: { change: _vm.onPageChange },
                scopedSlots: _vm._u([
                  {
                    key: "zhuangtai",
                    fn: function (text, record) {
                      return [
                        record.taskStatus === "待执行"
                          ? _c("span", { staticStyle: { color: "#3498db" } }, [
                              _vm._v("待执行"),
                            ])
                          : record.taskStatus === "已执行"
                          ? _c("span", { staticStyle: { color: "green" } }, [
                              _vm._v("已执行"),
                            ])
                          : record.taskStatus === "执行中"
                          ? _c("span", { staticStyle: { color: "orange" } }, [
                              _vm._v("执行中"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "xianchangjianchabiao",
                    fn: function (text, record) {
                      return [
                        record.xcjcbId
                          ? _c(
                              "a",
                              {
                                staticStyle: {
                                  color: "green",
                                  cursor: "pointer",
                                },
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$plugins.preview(
                                      record.xcjcbId,
                                      "pdf"
                                    )
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3498db",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.choiceImg(
                                      record,
                                      "现场检查表",
                                      "现场检查表"
                                    )
                                  },
                                },
                              },
                              [_vm._v("暂无")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "wentiquerenbiao",
                    fn: function (text, record) {
                      return [
                        record.wtqrbId
                          ? _c(
                              "a",
                              {
                                staticStyle: {
                                  color: "green",
                                  cursor: "pointer",
                                },
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$plugins.preview(
                                      record.wtqrbId,
                                      "pdf"
                                    )
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3498db",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.choiceImg(
                                      record,
                                      "问题确认表",
                                      "问题确认表"
                                    )
                                  },
                                },
                              },
                              [_vm._v("上传")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "jielun",
                    fn: function (text, record) {
                      return [
                        record.taskSumInfo
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "green",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onresultModalOpen(record)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3498db",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onresultModalOpen(record)
                                  },
                                },
                              },
                              [_vm._v("输入")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "jieguo",
                    fn: function (text, record) {
                      return [
                        record.taskPass === "待定"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#3498db",
                                  cursor: "pointer",
                                },
                              },
                              [_vm._v("待定")]
                            )
                          : record.taskPass === "通过"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "green",
                                  cursor: "pointer",
                                },
                              },
                              [_vm._v("通过")]
                            )
                          : record.taskPass === "未通过"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "orange",
                                  cursor: "pointer",
                                },
                              },
                              [_vm._v("未通过")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "caozuo",
                    fn: function (text, record) {
                      return [
                        record.taskPass === "待定" &&
                        record.taskStatus === "待执行"
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.execRandom(record)
                                  },
                                },
                              },
                              [_vm._v("执行检查")]
                            )
                          : _vm._e(),
                        record.taskPass === "待定" &&
                        record.taskStatus === "执行中"
                          ? [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.passRandom(record)
                                    },
                                  },
                                },
                                [_vm._v("通过")]
                              ),
                              _c("a-divider", {
                                attrs: { dashed: "true", type: "vertical" },
                              }),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.unPassRandom(record)
                                    },
                                  },
                                },
                                [_vm._v("未通过")]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("input", {
        ref: "hiddenFileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: { change: _vm.uploadFileChange },
      }),
      _vm.addDbRandomModalVisable
        ? _c("add-db-random-modal", {
            attrs: {
              visible: _vm.addDbRandomModalVisable,
              param: _vm.addDbRandomModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.addDbRandomModalVisable = $event
              },
              addDbRandomClose: _vm.onAddDbRandomModalClose,
            },
          })
        : _vm._e(),
      _vm.resultModalVisable
        ? _c("result-modal", {
            attrs: {
              visible: _vm.resultModalVisable,
              param: _vm.resultModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.resultModalVisable = $event
              },
              dialogBack: _vm.onresultModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }